import { array, InferType, object, string } from 'yup'

export const changeMembersCohortsSchemaValidation = object({
  cohorts: array().min(1).of(string().required()).required(),
}).required()

export type ChangeMembersCohortsSchemaValidationType = InferType<typeof changeMembersCohortsSchemaValidation>
